import React, { useState, useEffect, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Leaflet'in varsayılan ikonlarını düzeltme
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// Haritayı yeni konuma taşıyan bileşen
const FlyToLocation = ({ position }) => {
    const map = useMap();
    useEffect(() => {
        if (position) {
            map.flyTo(position, 13, {
                duration: 1.5, // Haritanın hareket süresi (saniye)
            });
        }
    }, [position, map]);

    return null;
};

const OpenLocation = () => {
    const [userLocation, setUserLocation] = useState(null); // Kullanıcının mevcut konumu
    const [markerPosition, setMarkerPosition] = useState(null); // Marker'ın bulunduğu konum
    const [searchQuery, setSearchQuery] = useState(""); // Arama kutusundaki metin
    const [suggestions, setSuggestions] = useState([]); // Adres önerileri
    const [error, setError] = useState(null); // Arama hataları

    // Kullanıcı konumunu alma
    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const currentLocation = [position.coords.latitude, position.coords.longitude];
                    setUserLocation(currentLocation);
                    setMarkerPosition(currentLocation);
                },
                (error) => {
                    console.error("Konum alınamadı:", error);
                    const defaultLocation = [51.505, -0.09];
                    setUserLocation(defaultLocation);
                    setMarkerPosition(defaultLocation);
                }
            );
        } else {
            console.error("Tarayıcı konum servisini desteklemiyor.");
            const defaultLocation = [51.505, -0.09];
            setUserLocation(defaultLocation);
            setMarkerPosition(defaultLocation);
        }
    }, []);

    // Adres tamamlama için Photon API
    const handleSearchChange = async (e) => {
        const query = e.target.value ; // Trim ile baştaki ve sondaki boşlukları temizle
        setSearchQuery(query);

        if (query.length > 2) {
            try {
                setError(null);
                const response = await fetch(
                    `https://photon.komoot.io/api/?q=${encodeURIComponent(query)}&lang=default`
                );
                const data = await response.json();

                if (data && data.features && data.features.length > 0) {
                    setSuggestions(
                        data.features.map((feat) => ({
                            name: feat.properties.name,
                            city: feat.properties.city || "",
                            country: feat.properties.country || "",
                            lat: feat.geometry.coordinates[1],
                            lon: feat.geometry.coordinates[0],
                        }))
                    );
                } else {
                    setSuggestions([]);
                }
            } catch (err) {
                setError("Adres önerileri alınamadı. Lütfen tekrar deneyin.");
                console.error(err);
            }
        } else {
            setSuggestions([]);
        }
    };

    // Öneri seçimi
    const handleSuggestionClick = (suggestion) => {
        const newPosition = [suggestion.lat, suggestion.lon];
        setMarkerPosition(newPosition);
        setUserLocation(newPosition); // Haritayı yeni marker konumuna taşı
        setSearchQuery(""); // Arama kutusunu temizle
        setSuggestions([]); // Önerileri temizle
    };

    return (
        <div style={{ position: "relative" }}>
            <h1>Konum Seçici</h1>

            {/* Arama Kutusu */}
            <div style={{ marginBottom: "10px" }}>
                <input
                    type="text"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    placeholder="Bir adres girin (ör: Etiler, İstanbul)"
                    style={{ width: "300px", padding: "5px" }}
                />
                {error && <p style={{ color: "red" }}>{error}</p>}
            </div>

            {/* Harita */}
            {userLocation ? (
                <div style={{ position: "relative", height: "500px" }}>
                    {/* Öneri Listesi */}
                    {suggestions.length > 0 && (
                        <ul
                            style={{
                                position: "absolute",
                                top: "0px",
                                left: "10px",
                                background: "white",
                                padding: "10px",
                                border: "1px solid #ccc",
                                zIndex: 1000,
                                maxHeight: "200px",
                                overflowY: "auto",
                                width: "300px",
                            }}
                        >
                            {suggestions.map((sug, index) => (
                                <li
                                    key={index}
                                    onClick={() => handleSuggestionClick(sug)}
                                    style={{
                                        padding: "5px",
                                        cursor: "pointer",
                                        borderBottom: "1px solid #ccc",
                                    }}
                                >
                                    {sug.name}, {sug.city}, {sug.country}
                                </li>
                            ))}
                        </ul>
                    )}

                    <MapContainer
                        center={userLocation}
                        zoom={13}
                        style={{ height: "100%", width: "100%" }}
                    >
                        <FlyToLocation position={userLocation} />
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution="&copy; OpenStreetMap contributors"
                        />
                        {markerPosition && (
                            <Marker
                                position={markerPosition}
                                draggable={true}
                                eventHandlers={{
                                    dragend: (e) => {
                                        const newPosition = [
                                            e.target.getLatLng().lat,
                                            e.target.getLatLng().lng,
                                        ];
                                        setMarkerPosition(newPosition);
                                    },
                                }}
                            >
                                <Popup>
                                    Marker konumu: <br />
                                    Enlem: {markerPosition[0].toFixed(4)} <br />
                                    Boylam: {markerPosition[1].toFixed(4)}
                                </Popup>
                            </Marker>
                        )}
                    </MapContainer>
                </div>
            ) : (
                <p>Konumunuz alınıyor...</p>
            )}
            {markerPosition && (
                <div>
                    <h3>Seçilen Konum:</h3>
                    <p>Enlem: {markerPosition[0]}</p>
                    <p>Boylam: {markerPosition[1]}</p>
                </div>
            )}
        </div>
    );
};

export default OpenLocation;